module.exports = __webpack_public_path__ + "dead.jpg?b6679f4b10841ed085f6870fc1124c78";


//////////////////
// WEBPACK FOOTER
// ./src/kits/1/images/dead.jpg
// module id = 486
// module chunks = 0